<template>
	<div class="modal fade" ref="modal">
		<div class="modal-dialog">
			<div v-if="uData != null" class="modal-content">
				<!-- <div class="modal-header">
          <h3 class="modal-title">Dados do usuário</h3>
        </div> -->
				<div class="modal-body">
					<!-- Dados de acesso  -->
					<h4 class="modal-title" style="margin-top: -15px">
						Dados de acesso
					</h4>
					<div class="row">
						<div class="col-sm-8">
							<span>Usuário</span>
							<input
								type="text"
								:value="uData.user"
								class="form-control"
								disabled
							/>
						</div>
						<div class="col-sm-4">
							<span>Perfil</span>
							<select
								class="form-control"
								v-model="uData.perfil.cod"
								disabled
							>
								<option
									v-for="(perfil, index) in assets.perfis"
									:key="index"
									:value="perfil.cod"
								>
									{{ perfil.desc }}
								</option>
							</select>
						</div>
						<div
							class="col-sm-6"
							:class="{ 'has-error': passDiff }"
						>
							<span>Senha</span>
							<input
								type="password"
								v-model="senha"
								class="form-control"
							/>
						</div>
						<div
							class="col-sm-6"
							:class="{ 'has-error': passDiff }"
						>
							<span>Repita a senha</span>
							<input
								type="password"
								v-model="rsenha"
								class="form-control"
							/>
						</div>
					</div>

					<!-- Dados comuns -->
					<h4 class="modal-title">Dados Comuns</h4>
					<div class="row">
						<div class="col-sm-6">
							<span>Nome</span>
							<input
								type="text"
								v-model="uData.uid.nome"
								class="form-control"
							/>
						</div>
						<div class="col-sm-6">
							<span>Sobrenome</span>
							<input
								type="text"
								v-model="uData.uid.sobrenome"
								class="form-control"
							/>
						</div>

						<div class="col-sm-6">
							<span>Telefone</span>
							<input
								type="text"
								class="form-control"
								placeholder="(99) 99999-9999"
								v-model="uData.uid.telefone"
								v-mask="'(##) #####-####'"
							/>
						</div>
						<div class="col-sm-6">
							<span>CPF</span>
							<input
								type="text"
								class="form-control"
								placeholder="999.999.999-99"
								v-mask="'###.###.###-##'"
								v-model="uData.uid.cpf"
							/>
						</div>

						<div class="col-sm-6">
							<span>Departamento</span>
							<select
								v-model="uData.uid.departamento.cod"
								class="form-control"
								disabled
							>
								<option
									v-for="(dep, index) in assets.departamentos"
									:key="index"
									:value="dep.cod"
								>
									{{ dep.titulo }}
								</option>
							</select>
						</div>
						<div class="col-sm-6">
							<span>Registro</span>
							<input
								v-model="uData.uid.registro"
								type="text"
								class="form-control"
							/>
						</div>

						<div class="col-sm-6">
							<span>Função</span>
							<input
								v-model="uData.uid.funcao"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-6">
							<span>Empresa</span>
							<input
								v-model="uData.uid.empresa"
								type="text"
								class="form-control"
							/>
						</div>
					</div>

					<!-- <pre>{{user_data}}</pre> -->
				</div>

				<div class="modal-footer">
					<a-btn
						action="protected-save-users"
						@click="save"
						text="Salvar"
						icon="save"
						type="primary"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import aBtn from 'btn';
	import { mapState } from 'vuex';
	import { clone } from 'lodash';
	import md5 from 'js/md5';
	import toastr from 'toastr';
	import WBS from 'js/http';

	export default {
		name: 'UpdateUserData',
		components: { aBtn },
		props: ['assets'],
		data() {
			return {
				uData: null,

				senha: '',
				rsenha: '',
				passDiff: false,
			};
		},
		watch: {
			senha: function (val) {
				this.uData.pass = 'altpass';
				if (this.rsenha == val) {
					this.uData.pass = md5.get(val);
					this.passDiff = false;
				} else {
					this.passDiff = true;
				}
			},
			rsenha: function (val) {
				this.uData.pass = 'altpass';
				if (this.senha == val) {
					this.uData.pass = md5.get(val);
					this.passDiff = false;
				} else {
					this.passDiff = true;
				}
			},
		},
		methods: {
			open() {
				this.uData = clone(this.user_data);
				this.senha = '';
				this.rsenha = '';
				this.uData.pass = '';

				$(this.$refs.modal).modal('show');
				// console.log(this.assets)
			},
			save() {
				if (this.uData.pass == 'altpass') {
					toastr.error('As senhas são diferentes...');
					return;
				}
				WBS.send('protected-save-users', this.uData, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$store.commit('UPDATE_USER_DATA', this.uData);
						$(this.$refs.modal).modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
		computed: {
			...mapState(['user_data']),
		},
	};
</script>
<style scoped>
	h4.modal-title {
		background: #e8e8e8;
		margin: 0 -15px;
		margin-top: 35px;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/cnt-app/components/userDataUpdate.vue